import { IProfile, IContent } from './content';
import { request } from './app';

export interface Content extends Partial<IContent> {
  id: string;
  title: string;
  image_url?: string;
  content_type: string;
  sort_order: number;
  type: string;
  active: boolean;
}

export interface Profile extends Partial<IProfile> {
  id: string;
  name: string;
  sort_order?: number;
}

export interface CategoryData {
  linked_content?: Content[];
  contents?: Content[];
  linked_topics?: Content[];
  profiles?: Profile[];
}

export interface ICategory {
  id: string;
  name: string;
  image_url?: string;
  content_type: string;
  sort_order: number;
  type: string;
}

export const getCategory =
  (uuid: string, token?: string) => async (): Promise<CategoryData> => {
    if (uuid === 'null' || uuid === null || uuid === '') return {};

    const response = await request(
      `${String(process.env.REACT_APP_API)}/categories/${uuid}?contents=true`,
      'GET',
      token,
    );

    if (!response.ok) {
      throw new Error('Problem fetching data');
    }

    const data = await response.json();
    return data?.data;
  };

export const getCategories =
  ({ token, uuid }: { token?: string; uuid?: string }) =>
  async (): Promise<ICategory[]> => {
    const response = await request(
      `${String(process.env.REACT_APP_API)}/apps/${uuid ?? ''}/categories`,
      'GET',
      token,
    );

    if (!response.ok) {
      throw new Error('Problem fetching data');
    }

    const data = await response.json();
    return data?.data;
  };
